/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Step } from './Step.js';
import {
    StepFromJSON,
    StepFromJSONTyped,
    StepToJSON,
} from './Step.js';

/**
 * 
 * @export
 * @interface ScriptStepResponse
 */
export interface ScriptStepResponse {
    /**
     * 
     * @type {Step}
     * @memberof ScriptStepResponse
     */
    data?: Step;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptStepResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptStepResponse interface.
 */
export function instanceOfScriptStepResponse(value: object): boolean {
    return true;
}

export function ScriptStepResponseFromJSON(json: any): ScriptStepResponse {
    return ScriptStepResponseFromJSONTyped(json, false);
}

export function ScriptStepResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptStepResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : StepFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptStepResponseToJSON(value?: ScriptStepResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': StepToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

